setTimeout(() => {
    document.querySelectorAll("[bss-b2b-btn-quickview]").forEach((e) => {
        e.addEventListener("click", function(e) {
            setTimeout(() => {

                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
            }, 2000);
        });
    });

    let variantEle = document.querySelectorAll('product-card .card-color-swatch-input--wrapper .card-color-swatch-input')
  console.log(variantEle)
    if (variantEle.length) {
        variantEle.forEach((e) => {
                e.addEventListener("mouseover", function(e) {
                 e.preventDefault();
                    e.stopPropagation();
                        let card = e.target.closest('product-card')
                        let price = card.querySelector('.product-price--regular[bss-b2b-product-id]')
                      if (price) {
                        console.log(price)
                        price.style.visibility = "hidden"
                      }
                    setTimeout(async () => {
                       
                        const res = await BSS_B2B.storage.productStorage.load();
                        BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', res)
                      
                    }, 200);
                   setTimeout( () => {
                       price.style.visibility = "visible"
                    }, 500);
                })
                e.addEventListener("click", function(e) {
                  e.preventDefault();
                    e.stopPropagation();
                   let card = e.target.closest('product-card')
                        let price = card.querySelector('.product-price--regular[bss-b2b-product-id]')
                      if (price) {
                        console.log(price)
                        price.style.visibility = "hidden"
                      }
                    setTimeout(async () => {
                       
                        const res = await BSS_B2B.storage.productStorage.load();
                        BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', res)
                      
                    }, 200);
                   setTimeout( () => {
                       price.style.visibility = "visible"
                    }, 500);
                });
            })
        }
  }, 2500);
